/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Destructive_Writes_Admin_OnlyInputs */



/**
* | output |
* | --- |
* | "This agent is shared, so only an administrator can change this. Make it private to change it yourself." |
*
* @param {Agent_Builder_Destructive_Writes_Admin_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_destructive_writes_admin_only = /** @type {((inputs?: Agent_Builder_Destructive_Writes_Admin_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Destructive_Writes_Admin_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Agent ist geteilt, daher kann nur eine Administratorin oder ein Administrator dies ändern. Machen Sie ihn privat, um es selbst zu ändern.")
	return /** @type {LocalizedString} */ ("This agent is shared, so only an administrator can change this. Make it private to change it yourself.")
});